import React, { useState, useEffect } from 'react';
import "../Konnect2022/konnect2022.css";
import CompaniesLogo from '../../../../../UI/Companies-Logo/CompaniesLogo';
import EventGallery from '../../../EventGallery';
import Image1 from "../../../../../../assets/gallery/i1.webp";
import Image2 from "../../../../../../assets/gallery/i2.webp";
import Image3 from "../../../../../../assets/gallery/i3.webp";
import Image4 from "../../../../../../assets/gallery/i4.webp";
import Image5 from "../../../../../../assets/gallery/i5.webp";
import Earth from "../../../../../../assets/konnect/earth.gif";
import Target from "../../../../../../assets/konnect/target.gif";
import Hotel from "../../../../../../assets/konnect/hotel.gif";
import Meeting from "../../../../../../assets/konnect/meeting.gif";
import Airoplane from "../../../../../../assets/konnect/airoplane.gif";
import Decision from "../../../../../../assets/konnect/decision.gif";
import Statistic from "../../../../../../assets/konnect/statistic.gif";
// Animated Stat Component
const AnimatedStat = ({ value, label }) => {
  const [count, setCount] = useState(0);
  const ref = React.useRef(null);

  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated) {
          setHasAnimated(true);

          const duration = 2000;
          const startTime = performance.now();

          const animate = (time) => {
            const progress = Math.min((time - startTime) / duration, 1);
            setCount(Math.floor(progress * value));

            if (progress < 1) requestAnimationFrame(animate);
          };

          requestAnimationFrame(animate);
        }
      },
      { threshold: 0.5 }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [value, hasAnimated]);

  return (
    <div className="stat-card  d-flex flex-column align-items-center justify-content-center text-center" ref={ref}>
      <span className="stat-number text-center justify-center">{count.toLocaleString()}+</span>
      <p className='fs-3 text-center'>{label}</p>
    </div>
  );
};


// Feature Video Hero Section
const HeroVideo = ({ isMuted, toggleSound }) => {
  const iframeRef = React.useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const message = isMuted
      ? '{"event":"command","func":"mute","args":""}'
      : '{"event":"command","func":"unMute","args":""}';

    iframe.contentWindow.postMessage(message, "*");
  }, [isMuted]);

  return (
    <div className="hero-video-wrapper">
      <iframe
        ref={iframeRef}
        className="full-bg-video"
        src="https://www.youtube.com/embed/qwbDyzlvgeE?autoplay=1&mute=1&loop=1&playlist=NrUijib5Iak&controls=0&modestbranding=1&rel=0&enablejsapi=1"
        title="IHN Konnect 2023 Highlights"
        frameBorder="0"
        allow="autoplay; encrypted-media"
        allowFullScreen
      />
        <div className="hero-overlay-content">
                    <div className="text-card-bottom">
                        <h2 className="fade-in-line">
                            <span className="hero-title-tag">Konnect 2.0 | 2023 Edition:</span>
                            <span className="hero-desc-tag">4th October 2023 | The Leela Ambience Convention Hotel | Delhi</span>
                        </h2>
                    </div>
                </div>
      <button className="sound-toggle-btn" onClick={toggleSound}>
        {isMuted ? "🔇" : "🔊"}
      </button>
    </div>
  );
};

export default function Konnect2023() {
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [isMuted, setIsMuted] = useState(true);

  const konnect2023Event = {
    title: "IHN Konnect 2023",
    gallery: [Image1, Image2, Image3, Image4, Image5],
    videoUrl: "https://youtu.be/qwbDyzlvgeE"
  };

  const toggleSound = () => setIsMuted(!isMuted);

  return (
    <div className="konnect-container">

      {/* Hero Video Section */}
      <section className="hero-section">
        <HeroVideo isMuted={isMuted} toggleSound={toggleSound} />
      </section>



      {/* Stats Section */}
      <section className="stats-grid">
        <AnimatedStat value={75} label="Global Sellers" />
        <AnimatedStat value={500} label="Premium Buyers" />
        <AnimatedStat value={12500} label="Successful Meetings" />
      </section>

      <section className="konnect-about my-5">
        <div className="konnect-about-container">
          <h1 className="heading text-center">
            About IHN Konnect 2023
          </h1>

          <p className="text-center text-light fs-4 align-justify">
            IHN Konnect 2023 was a <strong>high-impact, invite-only B2B networking experience</strong> for the hospitality,
            travel, tourism, MICE, and luxury travel ecosystem—delivering
            <strong> measurable business outcomes</strong> through curated access and structured engagement.
          </p>

          <p className="text-center text-light fs-4 align-justify">
            The event brought together
            <span className="konnect-highlight"> 500+ senior decision-makers</span> from
            <span className="konnect-highlight"> 26+ key Indian cities</span>, connecting verified buyers and
            solution-driven sellers from across India and select international markets.
            Delegates included CXOs, Owners, Commercial Heads, Sales Directors,
            Revenue Leaders, and Business Heads representing hotels, resorts,
            DMCs, airlines, cruise lines, tourism boards, event companies,
            and luxury travel brands.
          </p>

          <p className="text-center text-light fs-4 align-justify">
            Built on IHN’s proven
            <span className="konnect-highlight"> Curated Networking Format</span>,
            IHN Konnect 2023 facilitated
            <span className="konnect-highlight"> 12,500+ pre-scheduled, high-quality one-on-one B2B meetings</span>,
            ensuring optimal buyer-to-seller ratios and eliminating non-relevant interactions.
            Each meeting was designed for <strong>speed-to-business</strong>,
            enabling faster deal discovery, partnership alignment,
            and accelerated pipeline generation.
          </p>
        </div>
      </section>




      {/* Key Highlights Section */}
      <section className="highlights-section">
        <h1 className="heading text-center pb-3">Key Highlights</h1>
        <div className="highlights-grid container">
          {[
            { image: Target, text: "500+ pre-qualified B2B delegates" },
            { image: Airoplane, text: "India-focused with international business reach" },
            { image: Meeting, text: "12,500+ structured one-on-one meetings delivered" },
            { image: Hotel, text: "Hospitality, travel, tourism, MICE & luxury segments covered" },
            { image: Decision, text: "Invite-only, decision-maker-led participation" },
            { image: Statistic, text: "High buyer-to-seller conversion focus" }
          ].map((item, index) => (
            <div className="highlight-card" key={index}>
              <div className="highlight-icon">
                <img src={item.image} alt={item.text} className='highlight-image' />
              </div>

              <h4>{item.text}</h4>
            </div>
          ))}
        </div>
        {/* View Gallery Button Below Video */}
        <div className="text-center mt-4">
          <button
            className="btn-primary"
            onClick={() => setIsGalleryOpen(true)}
          >
            View Gallery
          </button>
        </div>
      </section>

      {/* Companies Section */}
      <section className="companies-section">
        <CompaniesLogo />
      </section>

      {/* Event Gallery */}
      <EventGallery
        isOpen={isGalleryOpen}
        onClose={() => setIsGalleryOpen(false)}
        event={konnect2023Event}
      />
    </div>
  );
}
